import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import Chart from "react-apexcharts";
import { actionFindAll } from "actions/action/actions";
import filterTypes from "data/filter-types";
import Spinner from "views/lib/components/Spinner";

const LastDayActivity = (props) => {
  const {
    actionFindAll,
    actionList
  } = props;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    actionFindAll(0, 10000, "start,asc", [{
      fieldName: "start",
      fieldValue: moment()
        .subtract(1, "days")
        .valueOf(),
      searchOperation: filterTypes.AFTER.value
    }]);
  }, []);

  useEffect(() => {
    if (actionList && actionList.content) {
      setLoading(false);
    }
  }, [actionList]);

  const groups = {};
  // eslint-disable-next-line no-prototype-builtins
  (actionList.hasOwnProperty("content") && Array.isArray(actionList.content) ? actionList.content : []).forEach(perRide => {
    const startTime = moment(perRide.started)
      .format("HH:00 YYYY-MM-DD")
      .valueOf();
    if (!groups[startTime]) {
      groups[startTime] = 0;
    }

    groups[startTime]++;
  });

  return (
    <div className="">
      <div className="mt-4">
        {!loading || <Spinner/>}
        <Chart
          options={{
            chart: {
              id: "last-24-hour-activity-bar",
              toolbar: {
                show: true
              },
              zoom: {
                enabled: true,
                type: "x",
                autoScaleYaxis: false,
                zoomedArea: {
                  fill: {
                    color: "#90CAF9",
                    opacity: 0.4
                  },
                  stroke: {
                    color: "#0D47A1",
                    opacity: 0.4,
                    width: 1
                  }
                }
              }
            },
            title: {
              text: "Last 24 hour activity",
              align: "left"
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "55%",
                endingShape: "rounded"
              },
            },
            stroke: {
              curve: "smooth"
            },
            xaxis: {
              categories: Object.keys(groups),
              type: "datetime",
              labels: {
                datetimeUTC: false
              }
            },
            markers: {
              size: 6,
              strokeWidth: 3,
              fillOpacity: 0,
              strokeOpacity: 0,
              hover: {
                size: 8
              }
            },
            dataLabels: {
              enabled: false
            },
            tooltip: {
              enabled: true,
              x: {
                show: true,
                format: "HH:00 MMM dd",
                formatter: undefined,
              },
            }
          }}
          series={[{
            name: "Ride Count",
            data: Object.keys(groups)
              .map(day => groups[day])
          }]}
          type="bar"
          width="100%"
          height={300}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  actionList: state.action.actionList,
});

const mapStateToDispatch = dispatch => ({
  actionFindAll: bindActionCreators(actionFindAll, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(LastDayActivity);



// WEBPACK FOOTER //
// ./src/views/pages/dashboard/LastDayActivity.js